module.exports = __webpack_public_path__ + "static/media/18-iveco-mercedes.3efa0ae2.jpg";